// extracted by mini-css-extract-plugin
module.exports = {"canvas":"imageStoryViewer_canvas__3XoUs"};